import { KeyRound, Tag, Handshake } from 'lucide-react';

// What a vehicle is listed for. Drives which fields the add/edit forms ask for.
export const PURPOSES = [
  { value: 'rental', title: 'Rent', icon: KeyRound, blurb: 'Customers book it by the day, hour or km' },
  { value: 'sale', title: 'Sell', icon: Tag, blurb: 'Buyers see the price and vehicle condition' },
  { value: 'both', title: 'Both', icon: Handshake, blurb: 'Available to rent, and open to offers' }
];

// forRent defaults to true on the model, so an older vehicle with no flag reads as rental.
export const purposeFromCar = (car) => {
  const rent = car?.forRent !== false;
  const sale = !!car?.forSale;
  if (rent && sale) return 'both';
  if (sale) return 'sale';
  return 'rental';
};

export const purposeTitle = (purpose) => PURPOSES.find((p) => p.value === purpose)?.title || '';

// What an owner may list a vehicle as, given their business setting. A shop that
// only sells has no rental option to offer and vice versa; 'both' keeps all three.
// Unknown falls back to 'both' so an account without the field set loses nothing.
export const purposesFor = (businessType) =>
  businessType === 'sale' ? PURPOSES.filter((p) => p.value === 'sale')
    : businessType === 'rental' ? PURPOSES.filter((p) => p.value === 'rental')
      : PURPOSES;

// Ordinal suffix: 1 -> "1st", 2 -> "2nd", 3 -> "3rd", 4 -> "4th" ... 11 -> "11th".
export const ordinal = (n) => {
  const v = n % 100;
  const s = ['th', 'st', 'nd', 'rd'];
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
};

// No. of previous owners for a used vehicle — 1st through 10th. Shared by the
// add/edit forms and the buy filter so the options never drift apart.
export const MAX_OWNERS = 10;
export const OWNER_OPTIONS = Array.from({ length: MAX_OWNERS }, (_, i) => ({
  value: String(i + 1),
  label: `${ordinal(i + 1)} Owner`,
}));

// Display label for a stored owner count (caps the label at 10th+ just in case).
export const ownerLabel = (n) =>
  !n ? '' : n >= MAX_OWNERS ? `${ordinal(MAX_OWNERS)}+ Owner` : `${ordinal(n)} Owner`;
